import React, {useEffect, useRef, useState} from 'react';
import {Button, Input, Select} from 'semantic-ui-react';
import {TimeInput} from '@trendmicro/react-datepicker';
import DatePick from './Datapiker/DataPicker';

import '@trendmicro/react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import {isDatePickerClick} from "./Datapiker/general";

const betObj = [
    {key: '11', text: 'CASH', value: 'CASH'},
    {key: '22', text: 'TOURNAMENT', value: 'TOURNAMENT'},
    {key: '22', text: 'SPIN', value: 'SPIN'},
];

// cols: ['Ticket ID',  'Amount', 'Date From', 'Date To', 'Player ID', 'Bet Type'],

const TicketFilter = ({filterTickets, reset, startDate, startTime, timeTo, isFilterInTab}) => {
    const [filterObj, setFilterObj] = useState({
        dateFrom: startDate ? startDate : moment().format('DD-MM-YYYY'),
        timeFrom: startTime ? startTime : moment().format('00:00:00'),
        dateTo: moment().format('DD-MM-YYYY'),
        timeTo: timeTo ? timeTo : moment().format('HH:mm:ss'),
        ticketId: '',
        playerId: '',
        betKind: '',
        amountFrom: '',
        amountTo: ''
    });
    const [betType, setBetType] = useState('');
    const [dateValueFrom, setDateValueFrom] = useState(moment().format('DD-MM-YYYY'));
    const [timeValueFrom, setTimeValueFrom] = useState(moment().format('00:00:00'));
    const [dateValueTo, setDateValueTo] = useState(moment().format('DD-MM-YYYY'));
    const [timeValueTo, setTimeValueTo] = useState(moment().format('HH:mm:ss'));
    const [showPicker, setShowPicker] = useState('');
    const [selectedBet, setSelectedBet] = useState(0);

    let refTo = useRef(null);
    let refFrom = useRef(null);

    useEffect(() => {
        if (startTime && startDate && timeTo) {
            setTimeValueFrom(startTime);
            setDateValueFrom(startDate);
            setTimeValueTo(timeTo);
        }

    }, [startDate, startTime]);


    const handleClick = (e) => {
        if ((showPicker === 'from' || showPicker === 'to') && refFrom.current && refTo.current && !isDatePickerClick(e.target)) {
            setShowPicker('')
        }

    };

    useEffect(() => {
        document.addEventListener('click', handleClick);
        return () => {
            document.removeEventListener('click', handleClick);
        };
    });
    const getTimeFrom = (value) => {
        setTimeValueFrom(value);
        setFilterObj((obj) => ({
            ...obj,
            timeFrom: value
        }))
    };
    const getTimeTo = (value) => {
        setTimeValueTo(value);
        setFilterObj((obj) => ({
            ...obj,
            timeTo: value
        }))
    };
    const openPicker = (e) => {
        setShowPicker(e);
    };
    const closeFromDatePicker = (obj) => {
        setDateValueFrom(obj);
        setFilterObj((object) => ({
            ...object,
            dateFrom: obj
        }));
        setShowPicker('');
    };
    const closeToDatePicker = (obj) => {
        setDateValueTo(obj);
        setFilterObj((object) => ({
            ...object,
            dateTo: obj
        }));
        setShowPicker('');
    };

    const handleFilter = () => {
        setShowPicker('');
        const obj = {
            dateFrom: filterObj.dateFrom + ' ' + filterObj.timeFrom,
            dateTo: filterObj.dateTo + ' ' + filterObj.timeTo,
            ticketId: filterObj.ticketId,
            betKind: filterObj.betKind,
            playerId: filterObj.playerId,
            amountFrom: filterObj.amountFrom,
            amountTo: filterObj.amountTo,

        };
        console.log(obj, "Ticket obj")

        filterTickets(obj);
    };
    const resetAll = () => {
        setShowPicker('');
        setBetType('');
        setDateValueFrom(moment().format('DD-MM-YYYY'));
        setTimeValueFrom(moment().format('00:00:00'));
        setDateValueTo(moment().format('DD-MM-YYYY'));
        setTimeValueTo(moment().format('HH:mm:ss'));
        setSelectedBet(0);
        setFilterObj((obj) => ({
            ...obj,
            dateFrom: moment().format('DD-MM-YYYY'),
            timeFrom: moment().format('00:00:00'),
            dateTo: moment().format('DD-MM-YYYY'),
            timeTo: moment().format('HH:mm:ss'),
            betKind: '',
            ticketId: '',
            playerId: '',
            amountFrom: '',
            amountTo: '',
        }));
        filterTickets({
            dateFrom: moment().format('DD-MM-YYYY') + ' ' + moment().format('00:00:00'),
            dateTo: moment().format('DD-MM-YYYY') + ' ' + moment().format('HH:mm:ss'),
        });
        if (reset)  reset();

    };
    const handleValue = (stateName, e) => {
        const val = e.target.value;
        setFilterObj((obj) => ({
            ...obj,
            [stateName]: +val
        }))

    };
    const getSelectValue = (name, data) => {
        if (data.value) {
            setBetType(data.value);
            setSelectedBet(1);
            setFilterObj((object) => ({
                ...object,
                betKind: data.value,


            }));
        }
    };

    return (
        <div className="input-box-game">
            <div className="filter-inputs flex-wrap">
                <div className="input-box game">
                    <div className="margin-l">
                        <div className='label'>Created At From:</div>
                        <div className="date-from">
                            <div className="ui left icon input date">
                                <input
                                    ref={refFrom}
                                    type="text"
                                    placeholder="Choose date..."
                                    size={10}
                                    value={dateValueFrom}
                                    onClick={() => openPicker('from')}
                                    onChange={() => openPicker('from')}
                                />
                                <i aria-hidden="true" className="calendar icon"/>
                            </div>
                            {showPicker === 'from' && (
                                <DatePick close={closeFromDatePicker} value={dateValueFrom}/>
                            )}
                            <div className="left">
                                <TimeInput
                                    value={timeValueFrom}
                                    onChange={(value) => getTimeFrom(value)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="margin-l-20">
                        <div className='label'>Created At To:</div>
                        <div className="date-to">
                            <div className="ui left icon input date">
                                <input
                                    ref={refTo}
                                    type="text"
                                    placeholder="Choose date..."
                                    size={10}
                                    value={dateValueTo}
                                    onClick={() => openPicker('to')}
                                    onChange={() => openPicker('to')}
                                />
                                <i aria-hidden="true" className="calendar icon"/>
                            </div>
                            {showPicker === 'to' && (
                                <DatePick close={closeToDatePicker} value={dateValueTo}/>
                            )}
                            <div className="left">
                                <TimeInput value={timeValueTo} onChange={(value) => getTimeTo(value)}/>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div className="input-box game">
                <div className="check-box">
                    <div className="label">Select Bet Type:</div>
                    {!selectedBet ? <>
                        {betType ? null : null}
                        <Select
                            selectOnBlur={false}
                            clearable
                            placeholder={'Not selected'}
                            options={betObj}
                            onChange={(e, data) => getSelectValue('betType', data)}
                        /></> : <Select
                        selectOnBlur={false}
                        clearable
                        placeholder={betType}
                        options={betObj}
                        onChange={(e, data) => getSelectValue('betType', data)}
                    />
                    }
                </div>
                {
                    !isFilterInTab ?
                        <div className="check-box">
                            <div className="label">Player ID:</div>
                            <Input
                                placeholder="Player ID"
                                value={filterObj.playerId ? filterObj.playerId : ''}
                                onChange={(e) => handleValue('playerId', e)}
                                type={'number'}
                            />
                        </div>:null

                }

            </div>

            <div className="input-box game">

                <div className="check-box">
                    <div className="label">Ticket ID:</div>
                    <Input
                        placeholder="Ticket ID"
                        value={filterObj.ticketId ? filterObj.ticketId : ''}
                        onChange={(e) => handleValue('ticketId', e)}
                        type={'number'}
                    />
                </div>

            </div>

            <div className="input-box game">
                <div className="check-box">
                    <div className="label">Amount:</div>
                    <div className="item">
                        <Input
                            label="From:"
                            value={filterObj.amountFrom ? filterObj.amountFrom : ''}
                            onChange={(e) => handleValue('amountFrom', e)}
                            type="number"
                            min={1}
                            size={"mini"}
                        />
                        <Input
                            label="To:"
                            value={filterObj.amountTo ? filterObj.amountTo : ''}
                            onChange={(e) => handleValue('amountTo', e)}
                            type="number"
                            min={1}
                            size={"mini"}
                        />
                    </div>
                </div>

            </div>


            <div className="filter-div">
                <Button primary className="filter-btn belote-green" onClick={handleFilter}>
                    Filter
                </Button>
                <Button className="filter-btn" onClick={resetAll}>
                    Reset All
                </Button>
            </div>

        </div>
    );
};
export default TicketFilter;
